import { createContext } from "react";

import Business from "api/types/Business";

const BusinessContext = createContext<{
	business: Business;
}>(undefined as any);

export default BusinessContext;
